// 报警日志
import request from '@/utils/request'

let CallmsgApi = {
  /*获取所有商户*/
  getSupplier(data, errorback) {
    return request._post('/shop/order.order/getSupplier', data, errorback);
  },
  /*报警记录*/
  callLog(data, errorback) {
    return request._get('/shop/order.order/callLog', data, errorback);
  },
  /*订单结算详情*/
  orderDetail(data, errorback) {
    return request._post('/shop/cash.order/detail', data, errorback);
  },
  /*订单审阅*/
  calldeal(data, errorback) {
    return request._post('/shop/order.order/deal', data, errorback);
  },

}

export default CallmsgApi;



// WEBPACK FOOTER //
// ./src/api/callmsg.js